import merge from "lodash.merge"

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P]
}

/**
 * Deep merge utility function.
 * Recursively merges objects, combining nested objects.
 * Useful for merging configuration objects.
 *
 * @param target - The target object to merge into
 * @param ...sources - Source objects to merge from
 * @returns The merged object
 *
 * @example
 * const target = { a: { b: 1, c: 2 } }
 * const source = { a: { b: 3 } }
 * deepMerge(target, source) // { a: { b: 3, c: 2 } }
 */
export function deepMerge<T extends Record<string, unknown>>(target: T, ...sources: Array<DeepPartial<T>>): T {
  return merge({}, target, ...sources)
}
